import { Component, Inject } from '@angular/core';
import { SIDE_EFFECT_DATA_TOKEN, SideEffectData } from '../models/types';
import { GroupService } from '../../../../../admin/services/group.service';
import { Group } from '../../../../../admin/models/group.model';
import { Rule } from '../../../../../common/models/flow.dto';
import { genId } from '../../../../../core/services/genId';

@Component({
    selector: 'side-effect-delete-notification',
    templateUrl: './side-effect-delete-notification.component.html' /*,
    styleUrls: ['./side-effect-delete-notification.component.scss']*/,
    standalone: false
})
export class SideEffectDeleteNotificationComponent {
    constructor(
        public _groupService: GroupService,
        @Inject(SIDE_EFFECT_DATA_TOKEN) public data: SideEffectData
    ) {
        if (!this.data.configuration)
            this.data.configuration = defaultSideEffectConfig();
    }
}

function defaultSideEffectConfig(): DeleteNotificationConfig {
    return {
        flowId: { name: 'Flow Id', ruleId: genId() } as Rule,
        workItemId: { name: 'Workorder Id', ruleId: genId() } as Rule,
    };
}

export interface DeleteNotificationConfig {
    flowId: Rule,
    workItemId: Rule
}
